/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _NewCareGiverFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import RouterService from "@ember/routing/router-service";
import Transition from "@ember/routing/transition";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import CrudJournalEventBaseComponent from "core/components/forc/abstract/crud-journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import CareGiver from "core/models/care-giver";
import CareGiverAddedJournalEvent, { CareGiverRoles } from "core/models/care-giver-added-journal-event";
import SemeiaSessionService from "core/services/session";
import { ValidatorMap } from "ember-changeset/types";
import { TaskInstance, restartableTask, timeout } from "ember-concurrency";
import IntlService from "ember-intl/services/intl";
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports
import DS from "ember-data";
import FetcherService from "core/services/fetcher";
import validateFrenchPhoneNumber from "core/validators/french-phone-number";
import validateSometimes from "core/validators/sometimes";
import { EmberChangeset } from "ember-changeset";
import { validatePresence } from "ember-changeset-validations/validators";
import styles from "./index.module.css";
let NewCareGiverFormComponent = (_class = (_NewCareGiverFormComponent = class NewCareGiverFormComponent extends CrudJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "styles", styles);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "fetcher", _descriptor4, this);
    _initializerDefineProperty(this, "careGiverSelected", _descriptor5, this);
    _initializerDefineProperty(this, "searchedBy", _descriptor6, this);
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
    _defineProperty(this, "roleOptions", CareGiverRoles);
    _defineProperty(this, "afterCancel", () => {
      const targetRoute = this.session.patient ? "patient-web.protected.consult.medical-synthesis" : "medics-web.protected.patients.patient.administrative";
      return this.router.replaceWith(targetRoute);
    });
    _defineProperty(this, "afterCompleted", () => {
      const targetRoute = this.session.patient ? "patient-web.protected.consult.medical-synthesis" : "medics-web.protected.patients.patient.administrative";
      return this.router.replaceWith(targetRoute);
    });
    _defineProperty(this, "queryCareGivers", _buildTask(() => ({
      context: this,
      generator: function* (property, event) {
        this.careGiverSelected = false;
        this.searchedBy = property;
        const query = event.target.value;
        if (query.length < 1) return [];

        // Bounce search
        yield timeout(400);
        const filterObject = {
          health_centre_id: this.args.patient.healthCentre.id
        };
        if (property == "lastName") {
          Object.assign(filterObject, {
            last_name: query
          });
        } else {
          Object.assign(filterObject, {
            first_name: query
          });
        }
        const careGivers = yield this.store.query("care-giver", {
          filter: filterObject
        });
        return careGivers;
      }
    }), null, "queryCareGivers", "restartable"));
  }
  get validations() {
    return Object.assign({}, this.journalEventClass.validations(this.intl), {
      phone: validateSometimes([validatePresence({
        presence: true,
        message: "Le numéro de téléphone ne peux être vide"
      }), validateFrenchPhoneNumber({
        message: "Le numéro de téléphone n'est pas valide"
      })], function () {
        return this.get("phone");
      })
    });
  }
  onCareGiverSelected(index) {
    this.careGiverSelected = true;
    this.searchedBy = undefined;
    const careGiver = this.queryCareGivers.lastSuccessful.value[index];
    this.changeset.set("lastName", careGiver.lastName);
    this.changeset.set("firstName", careGiver.firstName);
    this.changeset.set("role", careGiver.role);
    this.changeset.set("email", careGiver.email);
    this.changeset.set("phone", careGiver.phone);
    this.changeset.set("address", careGiver.address);
    this.changeset.set("comments", careGiver.comments);
  }
  get shouldDisplaySuggestions() {
    return !this.careGiverSelected && this.queryCareGivers.lastSuccessful?.value;
  }
  async save() {
    const je = await super.save();

    // We make sure we get the computed referent-lab
    // which is executed by PR-API every time
    // we save a care giver which may be a referent laboratory
    if (je.isValidLaboratory) {
      await this.fetcher.query("referent-lab-updated-journal-event", {
        filter: {
          patient_id: this.args.patient.id
        }
      });
    }
    return je;
  }
}, _defineProperty(_NewCareGiverFormComponent, "forcDisplayName", "Nouveau membre de l'entourage de soin"), _defineProperty(_NewCareGiverFormComponent, "fullComponentId", "care-giver/new"), _defineProperty(_NewCareGiverFormComponent, "journalEventClass", CareGiverAddedJournalEvent), _NewCareGiverFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "fetcher", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "careGiverSelected", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "searchedBy", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onCareGiverSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCareGiverSelected"), _class.prototype), _class);
export { NewCareGiverFormComponent as default };